module.exports = __webpack_public_path__ + "img/img14.f5d1250c.png";